import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";

import { Loader } from 'components/ApplicationLoader';

import styles from "./signinas.module.scss";
import cx from "classnames";
import _ from "lodash";

import AuthService from 'services/auth.service';

export default function SignInAs() {
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    if (location && location.search) {
      const params = new URLSearchParams(location.search);
      const at = params.get('at');
      const rt = params.get('rt');
      const next = params.get('next');

      if (at && rt) {
        AuthService.saveToken(at, rt);
        if (AuthService.isAuthenticated()) {
          const safeNext = next && next.startsWith('/') && !next.startsWith('//') ? next : '/';
          history.push(safeNext);
        }
      }
    }
  }, [])


  return (
    <div className={styles.loaderContainer}>
      <Loader title="Loading storyboard..." />
    </div>
  )
}